import { getClientContext } from 'utils/clientContextUtil';
import { DELAY_TIMOUT_MS, FORBIDDEN_ACCESS_CODE, NO_API_FAILED_ATTEMPT } from 'constants/general';
import { getDeviceContext } from 'utils/deviceContext';
import { Analytics } from 'utils/analytics';
import { queryParser } from 'utils/queryParseUtil';
import axios from 'axios';

const apiUrlMiddleware = (store) => (next) => async (action) => {
  const result = next(action);

  if (action.payload && action.payload.endPoint) {
    const {
      endPoint,
      method,
      isPaasApi,
      body,
      addHeader,
      success,
      failure,
      successParam,
      failedParam,
      version,
      useAuth = true,
      useEnvTag
    } = action.payload;
    const state = store.getState();
    const {
      config: {
        accessToken,
        bankId,
        userTrackingId,
        configUrls: { paasApiBaseUrl, libertyApiBaseiUrl },
        nativeAppData
      }
    } = state;
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    };
    const parsedParams = queryParser();
    const isApiPaasUrl = useEnvTag ? true : isPaasApi;

    const api = axios.create({
      baseURL: isApiPaasUrl ? paasApiBaseUrl : libertyApiBaseiUrl,
      headers: { ...headers }
    });

    const { isNative } = getDeviceContext();

    if (addHeader) {
      api.defaults.headers['Accept'] = 'application/json';
      api.defaults.headers.common['Content-Type'] = 'application/json';
      api.defaults.headers.common['Content-Type'] = 'application/json';
      api.defaults.headers.common['Content-Type'] = 'application/json';

      (api.defaults.headers.common['x-bpi-client-context'] =
        isNative && nativeAppData
          ? JSON.stringify(nativeAppData.clientContext)
          : getClientContext(bankId, userTrackingId)),
        (api.defaults.headers.common['x-bpi-service-context'] =
          isNative && nativeAppData ? nativeAppData.serviceContext : 'USER');
      api.defaults.headers.common['x-bpi-version'] = isApiPaasUrl ? '1.2.0' : version;
    }
    const newEndPoint = endPoint.replace(':bankId', bankId);

    if (accessToken) {
      api.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    }
    try {
      // start making calls
      if (process.env.NODE_ENV === 'development' && parsedParams?.stub === 'true') {
        //adding a forced delay to trigger MSW before making existing journey mocked API calls
        await delay(500);
      }
      const response = await callAPI(api, method, newEndPoint, body, 0);
      if (response.status >= 200 && response.status <= 299) {
        store.dispatch(success(response.data, successParam, response.status));
      }
      store.dispatch(Analytics.send());
    } catch (error) {
      store.dispatch(failure(error, failedParam));
      store.dispatch(Analytics.send());
    }
  }

  return result;
};
const delay = (duration) => new Promise((resolve) => setTimeout(resolve, duration));

const callAPI = async (api, method, newEndPoint, body, numberAttempt) => {
  // start making calls
  let response = null;
  switch (method) {
    case 'delete':
      response = await api.delete(newEndPoint).catch((error) => {
        if (error.response?.status === FORBIDDEN_ACCESS_CODE) {
          if (
            numberAttempt < NO_API_FAILED_ATTEMPT &&
            error.response.status === FORBIDDEN_ACCESS_CODE
          ) {
            delay(DELAY_TIMOUT_MS);
            return callAPI(api, method, newEndPoint, body, ++numberAttempt);
          }
        }
      });
      break;
    case 'post':
      response = await api.post(newEndPoint, body).catch((error) => {
        if (error.response?.status === FORBIDDEN_ACCESS_CODE) {
          if (
            numberAttempt < NO_API_FAILED_ATTEMPT &&
            error.response.status === FORBIDDEN_ACCESS_CODE
          ) {
            delay(DELAY_TIMOUT_MS);
            return callAPI(api, method, newEndPoint, body, ++numberAttempt);
          }
        }
      });
      break;
    case 'put':
      response = await api.put(newEndPoint, body).catch((error) => {
        if (error.response?.status === FORBIDDEN_ACCESS_CODE) {
          if (
            numberAttempt < NO_API_FAILED_ATTEMPT &&
            error.response.status === FORBIDDEN_ACCESS_CODE
          ) {
            delay(DELAY_TIMOUT_MS);
            return callAPI(api, method, newEndPoint, body, ++numberAttempt);
          }
        }
      });
      break;
    default:
      response = await api.get(newEndPoint).catch((error) => {
        if (error.response?.status === FORBIDDEN_ACCESS_CODE) {
          if (
            numberAttempt < NO_API_FAILED_ATTEMPT &&
            error.response.status === FORBIDDEN_ACCESS_CODE
          ) {
            delay(DELAY_TIMOUT_MS);
            return callAPI(api, method, newEndPoint, body, ++numberAttempt);
          }
        }
      });
      break;
  }
  return response;
};

export { apiUrlMiddleware };
